import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Productfeaturescomponent from './Productfeaturescomponent.js';
import getContent from 'pp-react-l10n';

class SidePanelcomponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showItems: 3
    };
  }
  render() {
    const articleInfo =this.props.articleInfo;
    const ebooks = articleInfo.content.ebooks || [];
    const offers = articleInfo.content.offers || [];
    const featured = articleInfo.content.featured || [];
    const getSidePanelTitle = getContent('staticContent');
    const slugId = this.props.articleInfo.content['url-slug'];
    return (
      <aside className="rightsectionContainer" id="right-sectionContainer">
      <div className = "sidepanel-component">
        <Productfeaturescomponent slugId ={slugId} name={getSidePanelTitle('brc.ebookHeading')} id = "ebooks"
          dataarray={ebooks} />
        <Productfeaturescomponent slugId ={slugId} name={getSidePanelTitle('brc.offersHeading')} id = "promotions"
          dataarray={offers} />
        <Productfeaturescomponent slugId ={slugId} name={getSidePanelTitle('brc.featuredproductHeading')} id = "featured"
          dataarray={featured} />
      </div>
      </aside>
    );
  }
}

export default SidePanelcomponent;

SidePanelcomponent.propTypes = {
  articleInfo: PropTypes.shape({
    content: PropTypes.shape({
      ebooks: PropTypes.array,
      offers: PropTypes.array,
      featured: PropTypes.array,
      ['url-slug']: PropTypes.string
    })
  })
};
